import AxiosService from './AxiosService'

class SolrConfigRestService {
  static getSolrConfig(): Promise<any> {
    return AxiosService.get('/settings/solr')
  }

  static updateSolrConfig(solrConfig: any): Promise<any> {
    return AxiosService.put('/settings/solr', solrConfig)
  }

  static deleteConfig(): Promise<any> {
    return AxiosService.delete('/settings/solr')
  }

  static testConnection(): Promise<any> {
    return AxiosService.get('settings/solr/connection')
  }

}

export default SolrConfigRestService
